import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse, UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllHatcheriesResponseModel, HatcheriesRequest, HatcheriesResponseModel } from '@gtpl/shared-models/masters';
import { HatcheriesAdapter } from './dto/hatcheries.adapter';
import { Hatcheries } from './hatcheries.entity';
import { HatcheriesDTO } from './dto/hatcheries.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';


@Injectable()
export class HatcheriesService {
    constructor(
      private logService:LogsService,
        @InjectRepository(Hatcheries)
        private hatcheriesRepository: Repository<Hatcheries>,
        private hatcheriesAdapter: HatcheriesAdapter,
    ){}
    /**
     * get hatcheries details
     * @param hatcheries 
     */
    // @LogActions({isAsync: true})
    async getHatcheriesDetailsWithoutRelations(hatcheries: string): Promise<Hatcheries> {
        // tslint:disable-next-line: typedef
        const hatcheriesResponse = await this.hatcheriesRepository.findOne({
          where: {hatcheriesName: Raw(alias => `hatcheries_name = '${hatcheries}'`)},
        });
        if (hatcheriesResponse) {
          return hatcheriesResponse;
        } else {
          return null;
        }
      }


      async createHatcheries(hatcheriesDto: HatcheriesDTO, isUpdate: boolean): Promise<HatcheriesResponseModel> {
        // console.log(statesDto);
        try {
          let previousValue;
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          if (!isUpdate) {
            const hatcheriesEntity = await this.getHatcheriesDetailsWithoutRelations(hatcheriesDto.hatcheriesName);
            if (hatcheriesEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new ErrorResponse(11104, 'Hatcheries already exists');
            }
          } else{
            const certificatePrevious = await this.hatcheriesRepository.findOne({where:{hatcheriesId:hatcheriesDto.hatcheriesId}})
            previousValue = certificatePrevious.hatcheriesName
            const hatcheryEntity = await this.getHatcheriesDetailsWithoutRelations(hatcheriesDto.hatcheriesName);
            if (hatcheryEntity) {
                if(hatcheryEntity.hatcheriesId!=hatcheriesDto.hatcheriesId){
                    throw new ErrorResponse(11104, 'Hatcheries already exists');
                }
            }
        }
          const convertedHatcheriesEntity: Hatcheries = this.hatcheriesAdapter.convertDtoToEntity(hatcheriesDto,isUpdate);
          const savedHatcheriesEntity: Hatcheries = await this.hatcheriesRepository.save(
            convertedHatcheriesEntity
          );
          const savedHatcheriesDto: HatcheriesDTO = this.hatcheriesAdapter.convertEntityToDto(convertedHatcheriesEntity);
            // console.log(savedStateDto);
          if (savedHatcheriesDto) {
            // generating resposnse
            const present = savedHatcheriesDto.hatcheriesName;
            const response = new HatcheriesResponseModel(true,1,isUpdate? 'Hatcheries Updated Successfully': 'Hatcheries Created Successfully')
            const displayValue = isUpdate?'Hatcheries Updated Successfully': 'Hatcheries Created Successfully'
            const name=isUpdate?'updated':'created'
            const userName = isUpdate?savedHatcheriesDto.updatedUser:savedHatcheriesDto.createdUser
            const newLogDto = new LogsDto(1,name, 'Hatcheries', savedHatcheriesDto.hatcheriesId, true, displayValue,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'Hatcheries saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
      }  

      async getAllHatcheries(req?:UserRequestDto): Promise<AllHatcheriesResponseModel> {
        // const page: number = 1;
        
        try {
          const HatcheriesDtos: HatcheriesDTO[] = [];
          //retrieves all companies
          const HatcheriesEntities: Hatcheries[] = await this.hatcheriesRepository.find({order :{'hatcheriesId':'ASC'}});
          //console.log(statesEntities);
          if (HatcheriesEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            HatcheriesEntities.forEach(HatcheriesEntity => {
              const convertedHatcheriesDto: HatcheriesDTO = this.hatcheriesAdapter.convertEntityToDto(
                HatcheriesEntity
              );
              HatcheriesDtos.push(convertedHatcheriesDto);
            });
            const response = new AllHatcheriesResponseModel(true,1,'Hl Percentage retrieved successfully',HatcheriesDtos);
            //generated response
            if(req?.createdUser){
              const newLogDto = new LogsDto(1,'view', 'Hatcheries', 0, true, 'Hl Percentage retrieved successfully',req.createdUser,'','')
              let res = await this.logService.createLog(newLogDto);
              console.log(res);
            }
            return response
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        
        } catch (err) {
          throw err;
        }
      }
      async getAllActiveHatcheries(): Promise<AllHatcheriesResponseModel> {
        // const page: number = 1;
        try {
            const hatcheriesDto: HatcheriesDTO[] = [];
            //retrieves all companies
            const HatcheriesEntities: Hatcheries[] = await this.hatcheriesRepository.find({ order: { 'hatcheriesId': 'ASC' },where:{isActive:true},
           });
         console.log(HatcheriesEntities)
            if (HatcheriesEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                HatcheriesEntities.forEach(hatcheriesEntity => {
                    const convertedhatcheriesDto: HatcheriesDTO = this.hatcheriesAdapter.convertEntityToDto(
                      hatcheriesEntity
                      
                    );
                    hatcheriesDto.push(convertedhatcheriesDto);
                });
                const response = new AllHatcheriesResponseModel(true, 11108, "Hatcheries retrieved successfully", hatcheriesDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); hatcheriesDto
            }
        } catch (err) {
            throw err;
        }
    }
      async activateOrDeactivateHatcheries(hatcheriesReq: HatcheriesRequest): Promise<HatcheriesResponseModel> {
        try {
            const hatcheriesExists = await this.getHatcheriesById(hatcheriesReq.hatcheriesId);
            if (hatcheriesExists) {
                if (hatcheriesReq.versionFlag !== hatcheriesExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current hatcheries information.Refresh and try again');
                } else {
                    
                        const hatcheriesStatus =  await this.hatcheriesRepository.update(
                            { hatcheriesId: hatcheriesReq.hatcheriesId },
                            { isActive: hatcheriesReq.isActive,updatedUser: hatcheriesReq.updatedUser });
                       
                        if (hatcheriesExists.isActive) {
                            if (hatcheriesStatus.affected) {
                                const hatcheriesResponse: HatcheriesResponseModel = new HatcheriesResponseModel(true, 10115, 'Hatcheries is de-activated successfully');
                                return hatcheriesResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Hatcheries is already deactivated');
                            }
                        } else {
                            if (hatcheriesStatus.affected) {
                                const HatcheriesResponse: HatcheriesResponseModel = new HatcheriesResponseModel(true, 10114, 'Hatcheries is activated successfully');
                                return HatcheriesResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Hatcheries is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
      async getActiveHatcheriesById(hatcheriesReq: HatcheriesRequest): Promise<HatcheriesResponseModel> {
        try {
          //retrieves all companies
          const HatcheriesEntities: Hatcheries = await this.hatcheriesRepository.findOne({
              where:{hatcheriesId:hatcheriesReq.hatcheriesId}
              });
              
              const hatcheriesData: HatcheriesDTO = this.hatcheriesAdapter.convertEntityToDto(HatcheriesEntities);
              if (hatcheriesData) {
                  const response = new HatcheriesResponseModel(true, 11101 , 'Hatcheries retrived Successfully',hatcheriesData);
                  return response;
              }
              else{
                  throw new ErrorResponse(11106,'Something went wrong');
              }
              // generating resposnse
      } catch (err) {
          throw err;
      }
    }

    async getHatcheriesById(hatcheriesId: number): Promise<Hatcheries> {
        //  console.log(employeeId);
            const Response = await this.hatcheriesRepository.findOne({
            where: {hatcheriesId: hatcheriesId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}


